import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as global from './global.service';
import { map } from 'rxjs/operators';
import { objsToCamelCase } from '../helpers/object.helper';


@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private httpOptions: object;
  private httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {

    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });

  }

  /**
   * Translates an object by sending it to a translation API endpoint.
   * The response from the API is converted to camel case.
   *
   * @example
   * const object = {
   *    "source": "es",
   *    "target": "en",
   *    "text": "Texto a traducir"
   * }
   *
   * @param {Object} object - The object containing data to be translated.
   * @return {Observable<any>} An observable containing the response from the API after translation, with keys converted to camel case.
   */
  public translate(object: object) {

    const httpParams: HttpParams = new HttpParams();
    this.httpOptions = {
      headers: this.httpHeaders,
      params: httpParams
    };

    return this.http.post(global.API_URL + '/api/translations', object, this.httpOptions).pipe(
      map((response: any) => {
        return objsToCamelCase(response);
      })
    );
  }

}
